import { Component } from '@theme/component';

/**
 * A custom element that renders a paginated and filterable blog posts list.
 */
class BlogPostsList extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    this.visibleCount = 6;
    this.currentFilter = 'all';
    this.blogItems = Array.from(this.querySelectorAll('.js-blog-post-item'));
    this.filterButtons = Array.from(this.querySelectorAll('.js-blog-filter__item'));

    if (this.refs.viewMoreNext) {
      this.handleLoadMore = this.handleLoadMore.bind(this);
      this.refs.viewMoreNext.addEventListener('click', this.handleLoadMore);
    }

    this.initFilters();
    this.applyFilterAndPagination();
  }

  disconnectedCallback() {
    this.refs.viewMoreNext?.removeEventListener('click', this.handleLoadMore);
    this.filterButtons.forEach(button => {
      button.removeEventListener('click', this.handleFilterClick);
    });
  }

  initFilters() {
    this.handleFilterClick = (e) => {
      const button = e.currentTarget;
      this.currentFilter = button.getAttribute('data-filter');
      this.visibleCount = 6; // Reset visible count on filter change

      // Update active state
      this.filterButtons.forEach(btn => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      this.applyFilterAndPagination();
    };

    this.filterButtons.forEach(button => {
      button.addEventListener('click', this.handleFilterClick);
    });
  }

  handleLoadMore(e) {
    e.preventDefault();
    this.visibleCount += 6;
    this.applyFilterAndPagination();
  }

  applyFilterAndPagination() {
    let matchCount = 0;
    
    this.blogItems.forEach(item => {
      const itemTags = item.getAttribute('data-tags') || '';
      const tagsArray = itemTags.split(' ');
      const matchesFilter = this.currentFilter === 'all' || tagsArray.includes(this.currentFilter);

      if (matchesFilter) {
        matchCount++;
        if (matchCount <= this.visibleCount) {
          item.style.display = '';
          item.classList.remove('is-hidden');
        } else {
          item.style.display = 'none';
          item.classList.add('is-hidden');
        }
      } else {
        item.style.display = 'none';
        item.classList.add('is-hidden');
      }
    });

    this.updateButtonVisibility(matchCount);
  }

  updateButtonVisibility(totalMatches) {
    if (this.refs.viewMoreNext) {
      if (totalMatches > this.visibleCount) {
        this.refs.viewMoreNext.style.display = '';
      } else {
        this.refs.viewMoreNext.style.display = 'none';
      }
    }
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
